import clsx from "clsx";
import React, { useState } from "react";
import { TextInput } from "../../../search/criteria/TextInput";
import { searchInputType } from "../../types/search/search";

export function SearchInput({
	searchInput,
}: {
	searchInput?: searchInputType;
}) {
	const [error, setError] = useState("");

	if (!searchInput) {
		return null;
	}

	const { id, label, placeholder, errorMessage, itemsLength, onInputChange } =
		searchInput;
	const [prevItemsLength, setPrevItemsLength] = useState(itemsLength);

	// Adjust error message on input change
	if (itemsLength !== prevItemsLength) {
		setPrevItemsLength(itemsLength);

		if (itemsLength === 0) {
			setError(errorMessage);
		} else {
			setError("");
		}
	}

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const input = e.target.value;
		setError("");

		if (input && itemsLength === 0) {
			setError(errorMessage);
		}

		onInputChange(input);
	};

	return (
		<div className={clsx("modal__search", { error })}>
			<TextInput
				id={id}
				name={id}
				placeholder={placeholder}
				label={label}
				error={error}
				onChange={handleChange}
				autoFocus
			/>
		</div>
	);
}
